//= require tools/countDown

function searchScrollable () {
  if ($('#search-scrollable').length > 0) {
    setAllValueButton();
    target_search_modal = ''
    $('#search-modal').on('shown.bs.modal', function () {
      $('#search-modal .modal-body').animate({
        scrollTop: $(target_search_modal).offset().top
      }, 500);
      $(target_search_modal).focus();
    });

    $(document).on('keyup', '#autocomplete_modal_search', function (e) {
      if (e.keyCode == 13) {
        $('#modal_search').submit();
      } else {
        $('#modal_search_quick_search_completed').val($(this).val())
      }
      
    });

    $(document).on('click', '[data-toggle-search]', function () {
      var target = $(this).data('target-input');
      target_search_modal = target;
      $('#search-modal').modal('show')
    });

    $(document).on('click', '#button-submit-filter-wrapper button', function () {
      $('#modal_search').submit();
    });

    $(document).on('click', '.clear-input-modal', function () {
      $('#search-modal select, #search-modal input').each(function (index, input) {
        if ($(input).data('select') == true) {
          $(input).val('').trigger('change')
        } else {
          $(input).val('')
        }
      })
    });

    $(document).on('change', '#search-modal select', function () {
      $('#search-scrollable button[data-target-input="'+$(this).attr('id')+'"]').html($(this).val());
    });

    function setAllValueButton () {
      $('#search-scrollable button').each(function() {
        setValueButton(this);
      });
    }
  
    function setValueButton (button) {
      var target = $($(button).data('target-input'));
  
      if (target.val()) {
        value = target.val()
        if (typeof value == 'object') {
          value = value.join(' - ')
        }
        $(button).html(value);
      } else {
        $(button).html($(button).data('init-value'));
      }
    }
  }
}

function hostingPageFormScanForEnter() {
  $('#search_keyword_2').on('keyup', function(event) {
    if (event.keyCode === 13)
    { event.preventDefault();
      $('.simple_form.search_subpage').submit()
    }
  })
}


$(document).ready(function() {
  searchScrollable()
  hostingPageFormScanForEnter()
})